/* eslint-disable react/display-name */

import React from 'react';

import { IntlProvider } from 'react-intl';

export const LangContext = React.createContext();

const { Provider, Consumer } = LangContext;

const langStorageKey = '@ep-language';

const defaultLang = 'tr';

export const LanguageProvider = ({ children, translations, defaultLanguage = defaultLang }) => {
  const [lang, setLang] = React.useState(defaultLanguage);

  const setDefaultLanguage = (language) => {
    return new Promise((resolve, reject) => {
      try {
        localStorage.setItem(langStorageKey, language);
        setLang(language);
        resolve(language);
      } catch (error) {
        reject(error);
      }
    });
  };

  const getDefaultLanguages = () => {
    return new Promise((resolve, reject) => {
      try {
        const langFromStorage = localStorage.getItem(langStorageKey);

        if (langFromStorage) {
          resolve(langFromStorage);
        } else {
          resolve(defaultLanguage);
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  const init = async () => {
    try {
      const language = await getDefaultLanguages();
      await setDefaultLanguage(language);
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    init();
  });

  const changeLanguage = async (language) => {
    if (lang === language) return;

    try {
      const response = await setDefaultLanguage(language);
      setLang(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Provider value={{ lang, changeLanguage }}>
      <IntlProvider locale={lang} messages={translations[lang]}>
        {children}
      </IntlProvider>
    </Provider>
  );
};

const Component = (Components) => (props) => (
  <Consumer>
    {(value) => {
      const { lang, changeLanguage } = value;
      return <Components {...props} lang={lang} changeLanguage={changeLanguage} />;
    }}
  </Consumer>
);

export default Component;
